export default function ApresentacaoMetodo() {
  const aprendizados = [
    {
      icon: 'ri-eye-line',
      title: 'Perceber sinais antes da crise',
      description: 'Identifique as mudanças sutis no comportamento que indicam que algo está prestes a escalar — antes que vire uma crise.'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Identificar gatilhos escondidos',
      description: 'Descubra o que está realmente provocando o comportamento: luz, barulho, rotina, fome, dor ou comunicação inadequada.'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Ajustar ambiente e comunicação',
      description: 'Faça mudanças simples no espaço e na forma de se comunicar que reduzem o estresse e previnem reações difíceis.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Aplicar estratégias práticas para cada situação',
      description: 'Tenha respostas concretas para recusa de banho, medicação, agitação noturna, acusações e muito mais.'
    }
  ];

  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">

        {/* Cabeçalho */}
        <div className="max-w-3xl mx-auto text-center mb-10 sm:mb-14 space-y-4">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
            O Protocolo de Prevenção de Crises ensina você a{' '}
            <span className="text-teal-600">agir antes que a situação se torne uma crise</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
            Dentro do protocolo você aprende a:
          </p>
        </div>

        {/* Checklist de aprendizados */}
        <div className="grid sm:grid-cols-2 gap-5 sm:gap-6 mb-10 sm:mb-14">
          {aprendizados.map((item, index) => (
            <div
              key={index}
              className="flex items-start gap-4 bg-white border border-teal-100 rounded-2xl p-5 sm:p-6 hover:border-teal-300 transition-colors duration-200"
            >
              {/* Checkmark */}
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 bg-teal-600 rounded-full mt-0.5">
                <i className="ri-check-line text-white text-base"></i>
              </div>
              <div className="space-y-1">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900">{item.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Rodapé da seção */}
        <div className="bg-teal-600 rounded-2xl px-6 sm:px-10 py-6 text-center text-white">
          <p className="text-base sm:text-lg leading-relaxed">
            Cada estratégia é <strong>prática e pode ser aplicada imediatamente</strong> — sem precisar de formação na área da saúde.
          </p>
        </div>

      </div>
    </section>
  );
}
